/* eslint-disable import/prefer-default-export */
import { get } from 'lodash';
import { now, stringToDate, getDayOfYear } from 'helpers/DateTimeHelper';

export const getNetworkPanel = ({ network, panels }) => {
  const items = get(panels, 'member', []);
  const networkPanels = items.filter(
    panel => get(panel, 'items.member.0.network', false) === network,
  );
  const networkPanel = get(networkPanels, '0');
  if (!networkPanel) return null;
  const startDay = getDayOfYear(now());

  const greaterOrEqualStartDay = item => {
    const startDate = get(item, 'startDate');
    const date = startDate ? stringToDate(startDate) : now();
    const dayOfYear = getDayOfYear(date);
    return dayOfYear <= startDay;
  };
  const schedule = networkPanel.items.member.filter(greaterOrEqualStartDay);

  return schedule;
};
